import api from './api'

export interface SystemLimits {
  cancellationMinDays: number
  minAdvanceNotice: number
  extensionNotice: number
  maxConcurrentPercent: number
  minConcurrentWorkers: number
  requestDeadlineMonth: number
  requestDeadlineDay: number
  requestsEnabled: boolean
  emailValidationRequired: boolean
}

export interface AuditLog {
  id: string
  userId: string
  userName: string
  action: string
  description: string
  metadata: Record<string, unknown> | null
  createdAt: string
  user: {
    id: string
    name: string
    email: string | null
  }
}

export const limitsService = {
  async getLimits(): Promise<SystemLimits> {
    const response = await api.get('/configuration/limits')
    return response.data.data
  },

  async updateLimits(data: Partial<SystemLimits>): Promise<SystemLimits> {
    const response = await api.put('/configuration/limits', data)
    return response.data.data
  },

  async toggleRequests(enabled: boolean): Promise<{ requestsEnabled: boolean; message: string }> {
    const response = await api.patch('/configuration/requests-toggle', { enabled })
    return { requestsEnabled: response.data.data.requestsEnabled, message: response.data.message }
  },

  async getAuditLogs(action?: string, limit?: number): Promise<AuditLog[]> {
    const params = new URLSearchParams()
    if (action) params.append('action', action)
    if (limit) params.append('limit', limit.toString())
    const response = await api.get(`/configuration/audit-logs?${params.toString()}`)
    return response.data.data
  },
}
